import { Box } from '@material-ui/core';
import {
  CreditCardBorrowerDocumentationRequired,
  DocumentationRequired,
  DocumentationRequiredType,
  PaymentMethodType,
} from '@nemuru-eng/js-api-client';

import { RequiredFilesList } from '@/components/modules/Documentation/components/DocumentationDetails/RequiredFilesList';
import { DocumentationRequiredHeader } from '@/components/modules/Documentation/components/DocumentationRequiredHeader/DocumentationRequiredHeader';
import { DocumentationCardParams } from '@/components/modules/Documentation/types/DocumentationCardParams';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { useScreen } from '@/hooks/useScreen';

interface DocumentationRequiredFilesProps {
  selectedDocumentationRequired: DocumentationRequired | CreditCardBorrowerDocumentationRequired;
  selectedDocumentationRequiredType: DocumentationRequiredType;
  paymentMethodId: string;
  paymentMethodType: PaymentMethodType;
  mode: DocumentationMode;
  borrowerId?: string;
  selectedDocumentationCardParams?: DocumentationCardParams;
}

export const DocumentationRequiredFiles = ({
  selectedDocumentationRequired,
  selectedDocumentationRequiredType,
  paymentMethodId,
  paymentMethodType,
  mode,
  borrowerId,
  selectedDocumentationCardParams,
}: DocumentationRequiredFilesProps) => {
  const { isMobile } = useScreen();

  return (
    <>
      {!isMobile && selectedDocumentationCardParams && (
        <Box pl={1} pr={'28px'} mb={2}>
          <DocumentationRequiredHeader
            loanId={paymentMethodId}
            documentationCardParams={selectedDocumentationCardParams}
            documentationRequired={selectedDocumentationRequired}
            mode={mode}
          />
        </Box>
      )}
      <CustomPaper fill="grey.light" style={{ padding: 16, height: isMobile ? 'inherit' : '404px' }}>
        <Box className={isMobile ? 'documentation-required-container-mobile' : 'documentation-required-container'}>
          {selectedDocumentationRequired.requiredFiles && (
            <RequiredFilesList
              requiredFiles={selectedDocumentationRequired.requiredFiles}
              documentationRequiredId={selectedDocumentationRequired.id}
              documentationRequiredType={selectedDocumentationRequiredType}
              mode={mode}
              paymentMethodType={paymentMethodType}
              paymentMethodId={paymentMethodId}
              borrowerId={borrowerId}
            />
          )}
        </Box>
      </CustomPaper>
    </>
  );
};
